import { render, staticRenderFns } from "./aibotLxy.vue?vue&type=template&id=6c973eb8&scoped=true&"
import script from "./aibotLxy.vue?vue&type=script&lang=js&"
export * from "./aibotLxy.vue?vue&type=script&lang=js&"
import style0 from "./aibotLxy.vue?vue&type=style&index=0&id=6c973eb8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c973eb8",
  null
  
)

export default component.exports